import { motion } from "framer-motion";

const TAGS = [
    "Instagram Growth",
    "LinkedIn",
    "TikTok",
    "WhatsApp Funnels",
    "Content Calendars",
    "Script Writing",
    "Web Design",
    "Sales Strategy",
    "Branding",
    "Funnel Optimisation",
    "Analytics",
];

export default function ServicesRecap() {
    return (
        <section
            id="services-recap"
            data-testid="services-recap-section"
            className="relative py-16 md:py-20"
        >
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <p className="text-xs uppercase tracking-[0.35em] text-[var(--accent-gold)] mb-4">
                    Everything Under One Roof
                </p>
                <h2 className="font-display font-bold text-3xl md:text-4xl leading-tight text-[var(--text-primary)] mb-8">
                    Full-stack growth,{" "}
                    <span className="italic text-[var(--accent-champagne)]">
                        one team.
                    </span>
                </h2>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7 }}
                    className="flex flex-wrap justify-center gap-2.5 md:gap-3"
                >
                    {TAGS.map((t) => (
                        <span
                            key={t}
                            data-testid={`services-recap-${t.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                            className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[var(--border-subtle)] hover:border-[var(--accent-gold)] bg-[rgba(255,255,255,0.02)] text-[var(--text-secondary)] hover:text-[var(--accent-champagne)] text-xs md:text-sm uppercase tracking-[0.16em] transition-colors"
                        >
                            <span className="w-1 h-1 rounded-full bg-[var(--accent-gold)]" />
                            {t}
                        </span>
                    ))}
                </motion.div>
            </div>
        </section>
    );
}
